import React from 'react';
import { Snackbar, Alert } from '@mui/material';

type Props = {
  open: boolean;
  message: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  onClose: () => void;
};

const GlobalSnackbar: React.FC<Props> = ({ open, message, severity = 'error', onClose }) => {
  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;


